type SuccessFn = (pos: GeolocationPosition) => void
type FailureFn = () => void

export function getCurrentGeo(success: SuccessFn, failure: FailureFn) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(success, failure, { enableHighAccuracy: true })
  } else {
    failure()
  }
}
